window.app_models.placement = {
    "id":null,
    "type":null,
    "insurance_company":null,
    "claim_number":null,
    "assigned_date":null,
    "loss_date":null,
    "move_in_date":null,
    "move_out_date":null,
    "closed_date":null,
    "stay_length":null,
    "ale_limit":null,
    "lost_file":null,
    "quickbooks":null,
    "loss_type":null,
    "adjuster_updated_at":null,
    "policyholder_updated_at":null,
    "public_adjuster_updated_at":null,
    "other_contact_updated_at":null,
    "user_id":null,
    "show_ale_limit":false,
    "claim_tbd":false,
    "show_ale_time":false,
    "frv_sent":null,
    "frv_sent_to": null,
    "policy_id":1,
    "lease_term_id":null,
    "pa_estimate_id":null,
    "ale_time_id":1,
    "lost_type_id":1,
    "frv_type":"",
    "sales_rep_id": null,
    "placement_contacts":[
        window.app_models.placement_contact
    ],
    "properties":[
        window.app_models.property
    ],
    "hotel_placements":[
        window.app_models.hotel_placement
    ],
    "active_properties":[
        window.app_models.property
    ],
    "active_and_moved_out_properties":[
        window.app_models.property
    ],
    "property":window.app_models.property,
    "policyholder":window.app_models.policyholder,
    "loss_address":window.app_models.loss_address,
    "budget":window.app_models.budget
};



// WEBPACK FOOTER //
// ./resources/assets/js/models/placement.js